// @flow
import * as React from 'react';
import cx from 'classnames';

import cs from './styles.pcss';

type Props = {
  status?: 'ok' | 'error' | 'inactive',
};

export default function Status({ status = 'ok' }: Props): React.Node {
  return <div className={cx(cs.status, cs[status])} />;
}
